import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { baseurl } from "../utility/helper";

const ChapterForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    chapter_name: "",
    chapter_desc: "",
    chapter_status: "",
    chapter_president: "",
    chapter_email: "",
    president_mobile: "",
  });

  const [errors, setErrors] = useState({}); // <-- for inline errors

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Clear error on change
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // Validation function
  const validate = () => {
    const newErrors = {};

    if (!formData.chapter_name.trim()) newErrors.chapter_name = "Chapter Name is required";
    if (!formData.chapter_desc.trim()) newErrors.chapter_desc = "Chapter Description is required";
    if (!formData.chapter_status) newErrors.chapter_status = "Please select status";
    if (!formData.chapter_president.trim()) newErrors.chapter_president = "President name is required";

    if (!formData.chapter_email) {
      newErrors.chapter_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.chapter_email)) {
      newErrors.chapter_email = "Email is invalid";
    }

    if (!formData.president_mobile.trim()) {
      newErrors.president_mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.president_mobile)) {
      newErrors.president_mobile = "Enter valid 10-digit mobile number";
    }

    setErrors(newErrors);

    // If no errors, return true
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return; // Stop submission if validation fails

    try {
      const response = await axios.post(`${baseurl}/admin/chapters`, formData);
      Swal.fire({
        title: "Success!",
        text: "Chapter Added successfully!",
        icon: "success",
        timer: 5000,
        timerProgressBar: true,
        willClose: () => {
          setTimeout(() => {
            navigate("/admin/ChapterList");
          }, 500);
        },
      });

      // Reset form
      setFormData({
        chapter_name: "",
        chapter_desc: "",
        chapter_status: "",
        chapter_president: "",
        chapter_email: "",
        president_mobile: "",
      });
    } catch (error) {
      console.error("Error inserting chapter:", error);
      Swal.fire("Error", "Failed to add chapter", "error");
    }
  };

  return (
    <div className="content container-fluid">
      <div className="profile-section">
        <div className="container mt-4">
          <center>
            <h2>Add New Chapter</h2>
          </center>
          <br />
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Chapter Name</label>
              <input
                type="text"
                className="form-control"
                name="chapter_name"
                value={formData.chapter_name}
                onChange={handleChange}
              />
              {errors.chapter_name && <small className="text-danger">{errors.chapter_name}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Chapter Long Description</label>
              <textarea
                className="form-control"
                name="chapter_desc"
                value={formData.chapter_desc}
                onChange={handleChange}
              ></textarea>
              {errors.chapter_desc && <small className="text-danger">{errors.chapter_desc}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Status</label>
              <select
                className="form-select"
                name="chapter_status"
                value={formData.chapter_status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.chapter_status && <small className="text-danger">{errors.chapter_status}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Chapter President</label>
              <input
                type="text"
                className="form-control"
                name="chapter_president"
                value={formData.chapter_president}
                onChange={handleChange}
              />
              {errors.chapter_president && <small className="text-danger">{errors.chapter_president}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">President Email</label>
              <input
                type="email"
                className="form-control"
                name="chapter_email"
                value={formData.chapter_email}
                onChange={handleChange}
              />
              {errors.chapter_email && <small className="text-danger">{errors.chapter_email}</small>}
            </div>

            <div className="col-md-6">
              <label className="form-label">President Mobile</label>
              <input
                type="text"
                className="form-control"
                name="president_mobile"
                value={formData.president_mobile}
                onChange={(e) => {
                  // Only allow numbers
                  const value = e.target.value.replace(/\D/g, "");
                  // Limit to 10 digits
                  if (value.length <= 10) {
                    setFormData({ ...formData, president_mobile: value });
                  }
                }}
              />
              {errors.president_mobile && (
                <small className="text-danger">{errors.president_mobile}</small>
              )}
            </div>


            <div className="col-12" style={{ textAlign: "center" }}>
              <Link to="/admin/ChapterList" style={{ color: "white" }}>
                <button className="btn btn-danger">Cancel</button>
              </Link>
              &nbsp;&nbsp;
              <button type="submit" style={{ borderRadius: "8px" }}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChapterForm;
